import { render, staticRenderFns } from "./SliderTeaser.vue?vue&type=template&id=2181e45f&scoped=true&"
import script from "./SliderTeaser.vue?vue&type=script&lang=js&"
export * from "./SliderTeaser.vue?vue&type=script&lang=js&"
import style0 from "./SliderTeaser.vue?vue&type=style&index=0&id=2181e45f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2181e45f",
  null
  
)

export default component.exports